// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2hrPC","col":"Table_col__DSUdr","fulfillmentStatus":"Table_fulfillmentStatus__10eMp","emailCol":"Table_emailCol__2gwJi"};